<template>
    <div class="modal-holder modal-info-texts">
        <div class="modal-card">
            <div
                class="modal-content scroll-bar"
                v-html="loginInformation"
            ></div>

            <div class="modal-buttons">
                <div class="buttons button-holder-right">
                    <label class="label-checkbox">
                        <input
                            class="checkbox-element"
                            type="checkbox"
                            v-model="hideModalOnLogin"
                        />
                        <div class="checkbox"></div>
                        Visa inte detta meddelande igen
                    </label>
                    <button class="button" @click="hideAndMaybeSave()">
                        Stäng
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { mapStores } from "pinia";
import { useAuthStore } from "../../stores/auth.js";

export default {
    computed: {
        ...mapStores(useAuthStore),
    },
    data() {
        return {
            hideModalOnLogin: false,
            loading: true,
            loginInformation:
                '<div class="loading"><div class="lds-ellipsis lds-ellipsis-blue"><div></div><div></div><div></div></div></div>',
        };
    },
    mounted() {
        // Load information text
        let self = this;
        axios
            .get(self.authStore.api + "/clp/information-text/", {
                headers: {
                    Authorization: "Bearer " + self.authStore.token,
                },
            })
            .then((response) => {
                console.log(response);
                self.loginInformation = response.data;
                self.loading = false;
            })
            .catch((error) => {
                console.log(error);
                self.loading = false;
            });
    },
    methods: {
        hide() {
            this.authStore.user.settings.hide_information = true;
            localStorage.setItem("user", JSON.stringify(this.authStore.user));
        },
        hideAndMaybeSave() {
            if (!this.hideModalOnLogin) {
                this.hide();
                return;
            }

            this.hide();

            let self = this;
            axios
                .post(
                    self.authStore.api + "/user/setMeta",
                    {
                        key: "hide_information",
                        value: true,
                    },
                    {
                        headers: {
                            Authorization: "Bearer " + self.authStore.token,
                        },
                    }
                )
                .then((response) => {
                    console.log(response);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>

<style>
.modal-card {
    width: 830px;
    max-width: calc(100% - 40px);
    padding: 20px 14px 20px 14px;
    background-color: #fff;
    border: 1px solid #617594;
    position: relative;
    display: flex;
    flex-direction: column;
    max-height: 90vh;
    box-shadow: 4px 4px 4px 0px #00000026;

    @media (min-width: 800px) {
        padding: 58px 50px 50px 50px;
    }

    h2 {
        font-size: 34px;
        line-height: 44px;
        letter-spacing: -1px;
        font-weight: 700;
        font-family: "hansen-grotesque-bold";
        margin-bottom: 14px;

        @media (min-width: 800px) {
            margin-bottom: 30px;
        }
    }

    h3 {
        font-size: 23px;
        line-height: 33px;
        font-weight: 700;
        font-family: "hansen-grotesque-bold";
        margin-bottom: 10px;
    }

    p {
        font-weight: 300;
        font-size: 16px;
        line-height: 23px;
        letter-spacing: 1px;
        font-family: "helvetica-regular";
        margin-bottom: 20px !important;

        @media (min-width: 800px) {
            margin-bottom: 50px !important;
        }
    }

    ul {
        list-style: disc;
        li {
            font-size: 16px;
            line-height: 23px;
            letter-spacing: 1px;
            font-family: "helvetica-regular";
            list-style: disc;
        }
    }
}

.modal-card-header {
    display: flex;
    align-items: center;

    @media (min-width: 800px) {
        margin-bottom: 20px;
    }
}

.modal-buttons {
    padding-top: 20px;
    @media (min-width: 800px) {
        padding-top: 50px;
    }

    .label-checkbox {
        margin-right: 8px;
    }
}
</style>
